import BaseDataProvider from '../../core/BaseDataProvider';
import { getUrlOrigin } from '../../utils/func';

class AtlasDataProvider extends BaseDataProvider {

	getStatus(referralUrl) {
		const url = `${getUrlOrigin(referralUrl)}/alive/`;
		return this.get(url);
	}

}

const provider = new AtlasDataProvider();
export default provider;
